import axios from "axios";

const BASE_API_URL = "/api/general";

class GeneralService {
  //G-1 出生地三層級聯查詢
  //  { level1?, level2?, level3? }
  //    - 全省略：回國家清單
  //    - 給 level1：回該國一級行政區清單
  //    - 給 level1+2：回二級行政區清單（僅台灣有）
  //    - 到最深一層：回 { fullName, lat, lng }
  birthplaceCascade({ level1, level2, level3 } = {}) {
    return axios.post(BASE_API_URL + "/birthplace-cascade", {
      level1,
      level2,
      level3,
    });
  }
}

export default new GeneralService();
